import { combineReducers } from '@reduxjs/toolkit';

import entities from '@sophocles/entities/entityReducer';
import alarms from '@sophocles/features/alarms';
import apiHealth from '@sophocles/features/apiHealth';
import authentication from '@sophocles/features/auth/authReducer';
import billing from '@sophocles/features/billing';
import pricingConfig from '@sophocles/features/billing/pricingConfigSlice';
import calendar from '@sophocles/features/calendar';
import capabilities from '@sophocles/features/capabilities';
import commands from '@sophocles/features/commands';
import contacts from '@sophocles/features/contacts/contactsSlice';
import customers from '@sophocles/features/customers';
import customerSettings from '@sophocles/features/customerSettings';
import dashboards from '@sophocles/features/dashboards';
import { entitiesApi } from '@sophocles/features/entities/entitiesApi';
import {
  site,
  siteUnit,
  siteAlarms,
  siteCommands,
  siteMeta,
  siteMaintenanceLogs,
} from '@sophocles/features/entities/site';
import features from '@sophocles/features/featureFlags';
import inventory from '@sophocles/features/inventory';
import map from '@sophocles/features/map/slice';
import media from '@sophocles/features/media';
import navigation from '@sophocles/features/navigation/navigationReducer';
import settingsNav from '@sophocles/features/navigation/settingsNavReducer';
import services from '@sophocles/features/projectServices';
import quickbooks from '@sophocles/features/quickbooks';
import reference from '@sophocles/features/reference';
import { operationalReportsReducer, siteGroupOperationalReportsReducer } from '@sophocles/features/reports';
import resourceHandler from '@sophocles/features/resources/resourceHandlerReducer';
import siteGroups from '@sophocles/features/siteGroups';
import siteGroupSettings from '@sophocles/features/siteGroupSettings';
import selectedPlant from '@sophocles/features/sites/slices/selectedPlant/reducer';
import selectedStructure from '@sophocles/features/sites/slices/selectedStructure/reducer';
import siteSensors from '@sophocles/features/siteSensors';
import siteSettings from '@sophocles/features/siteSettings';
import statuses from '@sophocles/features/status';
import tenant from '@sophocles/features/tenant';
import toasts from '@sophocles/features/toast/toastReducer';
import userPreferences from '@sophocles/features/userPreferences';
import userSettings from '@sophocles/features/userSettings';
import virtual from '@sophocles/features/virtual';
import warehouse from '@sophocles/features/warehouse';
import notify from '@sophocles/socket-io/slice';
// import { routerReducer } from 'react-router-redux';

const reducers = combineReducers({
  // routing: routerReducer,
  [entitiesApi.reducerPath]: entitiesApi.reducer,
  apiHealth,
  tenant,
  customers,
  dashboards,
  virtual,
  alarms,
  billing,
  calendar,
  capabilities,
  commands,
  contacts,
  map,
  media,
  authentication,
  notify,
  navigation,
  settingsNav,
  entities,
  features,
  selectedStructure,
  selectedPlant,
  warehouse,
  pricingConfig,
  inventory,
  services,
  operationalReports: operationalReportsReducer,
  siteGroupOperationalReports: siteGroupOperationalReportsReducer,
  reference,
  resourceHandler,
  toasts,
  statuses,
  quickbooks,
  siteGroups,
  siteGroupSettings,
  siteSettings,
  site,
  siteUnit,
  siteAlarms,
  siteCommands,
  siteMeta,
  siteMaintenanceLogs,
  siteSensors,
  customerSettings,
  userSettings,
  userPreferences,
});

export default reducers;
